import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useMemo, useState, useImperativeHandle } from 'react';
import isEqual from 'lodash/isEqual';
import { isEmpty } from "../utils/commonUtility";
import DropdownSelectedMenuList from "./DropdownSelectedMenuList";

var getValueFromOption = function getValueFromOption(option) {
  var _option$props;

  return option === null || option === void 0 ? void 0 : (_option$props = option.props) === null || _option$props === void 0 ? void 0 : _option$props.value;
};

var doesSetContainsValue = function doesSetContainsValue(set, value) {
  return Array.from(set).some(function (option) {
    return isEqual(option, value);
  });
};

var buildSelectedArray = function buildSelectedArray(map, newItem) {
  var selectedValues = Array.from(map);

  if (selectedValues.some(function (selectedItem) {
    return isEqual(selectedItem, newItem);
  })) {
    return selectedValues.filter(function (selectedItem) {
      return !isEqual(selectedItem, newItem);
    });
  }

  return [].concat(selectedValues, [newItem]);
};

var DropdownMenuList = /*#__PURE__*/React.forwardRef(function DropdownMenuList(_ref, ref) {
  var children = _ref.children,
      value = _ref.value,
      onChange = _ref.onChange,
      disabled = _ref.disabled,
      variant = _ref.variant;

  var _useState = useState(new Set()),
      _useState2 = _slicedToArray(_useState, 2),
      selectedOptionSet = _useState2[0],
      setSelectedOptionSet = _useState2[1];

  var isMultiSelect = variant === 'multiselect';
  var isChipSelect = variant === 'chip';
  var isSingleSelect = variant === 'single';
  useEffect(function () {
    if (!isEmpty(value)) {
      var selectedValue = isSingleSelect ? [value] : value;
      setSelectedOptionSet(new Set(selectedValue));
    }
  }, [value]);
  useImperativeHandle(ref, function () {
    return {
      reset: function reset() {
        setSelectedOptionSet(new Set());
      }
    };
  });

  var handleItemClick = function handleItemClick(e, menuItemValue) {
    e.stopPropagation();
    var selectedItems = isSingleSelect ? menuItemValue : buildSelectedArray(selectedOptionSet, menuItemValue);
    onChange(e, selectedItems);

    if (isChipSelect) {
      setSelectedOptionSet(new Set(selectedItems));
    }
  };

  var handleRemoveSelection = function handleRemoveSelection(e, menuItemValue) {
    e.stopPropagation();
    var selectedOptions = buildSelectedArray(selectedOptionSet, menuItemValue);
    setSelectedOptionSet(new Set(selectedOptions));
    onChange(e, selectedOptions);
  };

  var selectedOptions = useMemo(function () {
    if (!isMultiSelect) {
      return children;
    }

    return children.filter(function (option) {
      return doesSetContainsValue(selectedOptionSet, getValueFromOption(option));
    });
  }, [selectedOptionSet]);
  var shouldRenderSelectedMenuList = isMultiSelect && !isEmpty(selectedOptions);
  return /*#__PURE__*/React.createElement(React.Fragment, null, shouldRenderSelectedMenuList && /*#__PURE__*/React.createElement(DropdownSelectedMenuList, {
    onChange: handleRemoveSelection
  }, selectedOptions), React.Children.map(children, function (option) {
    if (isMultiSelect && doesSetContainsValue(selectedOptionSet, getValueFromOption(option))) {
      return null;
    }

    return /*#__PURE__*/React.cloneElement(option, {
      selected: !isMultiSelect ? doesSetContainsValue(selectedOptionSet, getValueFromOption(option)) : false,
      onClick: handleItemClick,
      multiselect: !isSingleSelect,
      disabled: disabled
    });
  }));
});
DropdownMenuList.displayName = 'DropdownMenuList';
export default DropdownMenuList;